<template>
  <div v-if="societe">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('addAgence.mailBat.titleModification') }}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button class="button is-cancel btn-modal-annuler" @click="$router.go(-1)">
              {{ $t('general.button.cancel')}}
            </button>
            <button class="button is-addOrEdit" @click="saveAgence()">
              {{ $t('general.button.sauvegarder') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <error-msg-component
      :messages="messages"
      :error="error"
      :title="'general.problemOccurred'"
      :withEmplyFields="true"
      @close="error = $event"
    />

    <div class="tab">
      <ul v-if="activeTab">
        <li
          v-for="tab in tabs" :key="tab.value"
          :class="{'is-active': activeTab.value === tab.value}"
          @click="activeTab = tab">
          {{ tab.title }}
        </li>
      </ul>
    </div>

    <div>
      <div class="column is-12">
        <div class="card">
          <header class="header-card">
            <p> {{ $t('addAgence.mailBat.informations')}} </p>
          </header>
          <div class="card-content">
            <div class="columns is-multiline">
              <div class="column is-3">
                <selection-agence
                  v-model="agenceId"
                  @input="gestionAgence"
                  obligatoire set-first-agence-find
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <edit-mail-bat
        v-if="agence"
        v-model="agence[activeTab.value]"
        :key="activeTab.value"
        :title="activeTab.title"
      />
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { get as getSociete, update as updateSociete } from '@/api/societe/index';
import messageErreur from '@/services/general/messageErreur';
import validation from '@/services/parametrage/validation/validationSociete';
import messageSuccess from '@/services/general/messageSucces';
import AppBreadcrumb from '@/components/general/breadcrumb';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import SelectionAgence from '@/components/general/selectionAgence';
import editMailBat from '@/components/parametrage/agence/editMailBat';

const societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      activeTab: null,
      societe: null,
      agenceId: null,
      agence: null,
      messages: [],
      error: false,
    };
  },
  components: {
    AppBreadcrumb,
    errorMsgComponent,
    SelectionAgence,
    editMailBat,
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agenceActive: 'agenceActive',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('listeUtilisateur.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeUtilisateur.parametrage'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('addAgence.mailBat.titleModification'), route: { name: '' }, isActive: true },
      ];
    },
    tabs() {
      return [
        { value: 'emailBat', title: this.$t('addAgence.mailBat.tab.emailBat') },
        { value: 'emailDemandeVisuel', title: this.$t('addAgence.mailBat.tab.emailDemandeVisuel') },
        { value: 'emailTransmisPAO', title: this.$t('addAgence.mailBat.tab.emailTransmisPAO') },
        { value: 'emailValidationVRP', title: this.$t('addAgence.mailBat.tab.emailValidationVRP') },
      ];
    },
  },
  methods: {
    gestionAgence(agenceId) {
      if (agenceId) this.agenceId = agenceId;
      const agence = this.societe.agences.find(a => a.id === this.agenceId);
      agence.emailBat = agence?.emailBat || '';
      agence.emailDemandeVisuel = agence?.emailDemandeVisuel || '';
      agence.emailTransmisPAO = agence?.emailTransmisPAO || '';
      agence.emailValidationVRP = agence?.emailValidationVRP || '';
      this.agence = agence;
    },
    async saveAgence() {
      const loadingComponent = this.$buefy.loading.open();
      this.messages = [];
      this.error = false;
      const indexAgence = this.societe.agences.find((agence) => agence.id === this.agenceId);
      this.societe.agences[indexAgence] = this.agence;
      try {
        await updateSociete(this.societe);
        messageSuccess(this.$i18n.t('addAgence.success.update'));
        this.$router.push({ name: 'l.parametrage.general' });
        return loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          validation(e.response, this.messages);
          this.error = true;
          return loadingComponent.close();
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    this.activeTab = this.tabs[0];
    try {
      this.societe = (await getSociete(this.societeActiveId)).data.result;
      this.gestionAgence(this.agenceActive[0].agenceId);
      this.setInformationPage(this.$t('pageParametrage.agence.mailBat'));
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};
</script>
